import { Facet } from '@epicuro-next/data/engagement/engagement-models';

export function mapFiltersFacets(filters: string) {
  const decodeFilters = decodeURIComponent(filters);
  const splitFilters = decodeFilters.split(',');

  const facets = splitFilters.reduce((collection, filter) => {
    const [attribute, value] = filter.split(/:(.+)/);
    const facet = { attribute, value };

    return [...collection, facet];
  }, [] as Facet[]);

  return facets ?? [];
}
